import React from "react";
import { X, ChevronLeft } from "lucide-react";
import { colors } from "@/constant/colors";


interface SchedulePopupProps {
  onClose: () => void;
  onBack?: () => void;
  children?: React.ReactNode;
  className?: string;
}

const SchedulePopup = ({ onClose, onBack, children, className }: SchedulePopupProps) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* 背景遮罩 */}
      <div className="fixed inset-0 bg-black/40" onClick={onClose} />
      {/* 弹窗主体 */}
      <div className={`relative bg-gray-100 rounded-2xl shadow-xl w-fit px-10 mx-4 py-4 z-10 ${className}`}>
        {/* 左上角返回 */}
        {onBack && (
          <button
            className="absolute left-4 top-4 text-gray-500 hover:text-black text-lg font-bold cursor-pointer"
            onClick={onBack}
            style={{ color: colors.mainTextColor }}
          >
            <div className="flex flex-row items-center gap-2">
              <ChevronLeft className="w-6 h-6" />
              Back
            </div>
          </button>
        )}
        {/* 右上角关闭 */}
        <button
          className="absolute right-4 top-4 text-gray-500 hover:text-black text-xl font-bold cursor-pointer"
          onClick={onClose}
          style={{ color: colors.mainTextColor }}
        >
          <X className="w-6 h-6" />
        </button>
        {/* 内容区 */}
        <div className="mt-10 mb-4">
          {children || 'schedule_popup'}
        </div>
      </div>
    </div>
  );
};

export default SchedulePopup;